import { MenuItemInterface } from '../interfaces/menu-item.interface';
import { APP_ROUTES } from './app-routes.constant';

export const ACCOUNT_MENU_ITEMS: MenuItemInterface[] = [
  {
    label: 'Inicio',
    url: APP_ROUTES.myAccount.url
  },
  {
    label: 'Meus Dados',
    url: APP_ROUTES.myAccount.children.myData.url
  },
  {
    label: 'Meus Planos',
    url: APP_ROUTES.myAccount.children.myPlans.url
  },
  {
    label: 'Meus Serviços',
    url: APP_ROUTES.myAccount.children.myServices.url
  }
];
